import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function CategoryGrid() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            福利资源分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            八大福利品类，覆盖日常生活的方方面面，点击进入查看详细福利资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg mb-4 ${
                  cat.color === "primary"
                    ? "bg-primary-100 text-primary-600"
                    : cat.color === "accent"
                    ? "bg-accent-100 text-accent-600"
                    : "bg-secondary-100 text-secondary-600"
                }`}
              >
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.resourceCount} 项资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}